import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './YearFilter.scss';

interface YearFilterProps {
    onYearChange: (year: string) => void;
    initialYear?: string;
    placeholder?: string;
    label?: string;
    disabled?: boolean;
    className?: string;
}

export const YearFilter: React.FC<YearFilterProps> = ({
    onYearChange,
    initialYear = new Date().getFullYear().toString(),
    placeholder = "YYYY",
    label,
    disabled = false,
    className = ""
}) => {
    const { t } = useTranslation();
    const [year, setYear] = useState(initialYear);

    const handleYearChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const newYear = e.target.value;
        setYear(newYear);
    };

    const handleLoadClick = () => {
        onYearChange(year);
    };

    const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter') {
            handleLoadClick();
        }
    };

    return (
        <div className={`year-filter ${className}`}>
            <div className="year-filter__input-section">
                {label && (
                    <label className="year-filter__label">
                        {label}
                    </label>
                )}
                <div className="year-filter__input-wrapper">
                    <input
                        type="number"
                        value={year}
                        onChange={handleYearChange}
                        onKeyPress={handleKeyPress}
                        placeholder={placeholder}
                        min="2020"
                        max="2030"
                        disabled={disabled}
                        className="year-filter__input"
                    />
                    <div className="year-filter__calendar-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                            <path
                                d="M6.66699 1.66666V4.99999M13.3337 1.66666V4.99999M2.50033 8.33332H17.5003M4.16699 3.33332H15.8337C16.7541 3.33332 17.5003 4.07952 17.5003 4.99999V16.6667C17.5003 17.5871 16.7541 18.3333 15.8337 18.3333H4.16699C3.24652 18.3333 2.50033 17.5871 2.50033 16.6667V4.99999C2.50033 4.07952 3.24652 3.33332 4.16699 3.33332Z"
                                stroke="currentColor"
                                strokeWidth="1.67"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>
                </div>
            </div>
            <button
                onClick={handleLoadClick}
                disabled={disabled || !year}
                className="year-filter__load-btn"
                type="button"
            >
                {t('LOAD') || 'Load'}
            </button>
        </div>
    );
};